var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled from 'styled-components';
var ToolTipSpanStyle = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @media (pointer: coarse), (hover: none) {\n    [title] {\n      position: relative;\n      display: inline-flex;\n      justify-content: center;\n    }\n    [title]:focus::after {\n      content: attr(title);\n      position: absolute;\n      top: 90%;\n      color: #000;\n      background-color: #fff;\n      border: 1px solid;\n      width: fit-content;\n      padding: 3px;\n    }\n  }\n"], ["\n  @media (pointer: coarse), (hover: none) {\n    [title] {\n      position: relative;\n      display: inline-flex;\n      justify-content: center;\n    }\n    [title]:focus::after {\n      content: attr(title);\n      position: absolute;\n      top: 90%;\n      color: #000;\n      background-color: #fff;\n      border: 1px solid;\n      width: fit-content;\n      padding: 3px;\n    }\n  }\n"])));

var ToolTipSpan = function ToolTipSpan(_a) {
  var children = _a.children,
      _b = _a.title,
      title = _b === void 0 ? '' : _b;
  return React.createElement(ToolTipSpanStyle, {
    title: title
  }, children);
};

export default ToolTipSpan;
var templateObject_1;